import React from 'react'

import Text from 'components/common/Text'

import { Tab } from '../styles'

const imgProps = {
    alt: 'focus-mode-icon',
    src: '/assets/revamp/focus.svg',
    height: '80%',
    width: '80%',
}

const FocusMode = ({ isActive }) => {
    return (
        <Tab.Area isActive={isActive}>
            <Tab.Icon>
                <img {...imgProps} />
            </Tab.Icon>
            <Tab.Title>
                <Text level="2">Focus Mode</Text>
            </Tab.Title>
        </Tab.Area>
    )
}

export default FocusMode
